export const POPOVER_OPTIONS: object = {
  placement: "auto-end",
  strategy: "fixed",
  modifiers: [
    {
      name: "offset",
      options: {
        offset: [0, 10],
      },
    },
  ],
};
